import React from 'react'

import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function highlightText(
  text: string,
  searchTerm: string,
): React.JSX.Element {
  if (!searchTerm) return <>{text}</>

  const parts = text.split(new RegExp(`(${searchTerm})`, 'gi'))
  return (
    <>
      {parts.map((part, index) =>
        part.toLowerCase() === searchTerm.toLowerCase() ? (
          <span
            key={index}
            className={cn('bg-primary', 'dark:text-background')}
          >
            {part}
          </span>
        ) : (
          part
        ),
      )}
    </>
  )
}

export function getDisplayTextFromUrl(url: string): string {
  try {
    const urlObj = new URL(url)
    // Remove 'www.' prefix if present
    const hostname = urlObj.hostname.replace(/^www\./, '')

    // If hostname is short (like "goto"), include the first path segment
    if (hostname.length <= 10 && urlObj.pathname && urlObj.pathname !== '/') {
      const firstPathSegment = urlObj.pathname.split('/')[1]
      if (firstPathSegment) {
        return `${hostname}/${firstPathSegment}`
      }
    }

    return hostname
  } catch {
    // Fallback to original URL if parsing fails
    return url
  }
}

export function generateSuccessFactorsRedirect(originalUrl: string): string {
  // Validate input URL
  if (!originalUrl || typeof originalUrl !== 'string') {
    return originalUrl || ''
  }

  try {
    const url = new URL(originalUrl)

    // Only proceed if it is from Career Connect
    if (url.hostname !== 'exxonmobil.plateau.com') return originalUrl

    const params = url.searchParams
    const componentID = params.get('componentID')
    const componentTypeID = params.get('componentTypeID')
    const revisionDate = params.get('revisionDate')

    if (!componentID || !componentTypeID || !revisionDate) {
      return originalUrl
    }

    // Construct the deeplink using the correct endpoint for SSO
    const deeplink = new URL(
      'https://exxonmobil.plateau.com/learning/user/deeplink_redirect.jsp',
    )
    deeplink.searchParams.set('linkId', 'ITEM_DETAILS')
    deeplink.searchParams.set('componentID', componentID)
    deeplink.searchParams.set('componentTypeID', componentTypeID)
    deeplink.searchParams.set('revisionDate', revisionDate)
    deeplink.searchParams.set('targetStudentSysGUID', '')
    deeplink.searchParams.set('actingAs', '')
    deeplink.searchParams.set('fromSF', 'Y') // Critical for SSO authentication

    // Encode the deeplink for use in the redirect
    const encodedDestUrl = encodeURIComponent(deeplink.toString())

    // Construct the final SuccessFactors redirect URL
    const redirectUrl = `https://performancemanager4.successfactors.com/sf/learning?destUrl=${encodedDestUrl}&company=exxonmobilP`

    return redirectUrl
  } catch (_error) {
    // If URL construction fails, return the original URL
    return originalUrl
  }
}
